import BaseResource from './BaseResource'

export default class Zones extends BaseResource {
  static endpoint = '/api/v1/zones' ///profile
}
